import { render } from "./ImageVariableIcon.vue?vue&type=template&id=c0f2dd8a&ts=true"
import script from "./ImageVariableIcon.vue?vue&type=script&lang=ts"
export * from "./ImageVariableIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src2094796596/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__